export default "__VITE_ASSET__BaVRAELr__"